import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { RulesSection } from './_sections/RulesSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';
import { WinnersSection } from './_sections/WinnersSection.tsx';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const winners = competitions.find((c) => c.slug === 'june_2025_campaign')?.winners;
  const allWinners = [...competitions].reverse().flatMap((d) => d.winners);
  return { activeCompetition, winners, allWinners };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Juni trekning">
      <div className="w-full bg-white">
        <TopSection activeCompetition={loaderData.activeCompetition} winners={loaderData.winners} />
        <TimerSection activeCompetition={loaderData.activeCompetition} />
        <WinnersSection allWinners={loaderData.allWinners} />
        <RulesSection activeCompetition={loaderData.activeCompetition} />
      </div>
    </Page>
  );
}
